import { MODAL_EXTERNAL_URL } from './externalUrl'
import { MODAL } from './modal'

const TEMPLATE = /*html*/ `
${MODAL}
`

export { TEMPLATE, MODAL_EXTERNAL_URL }
